import { action } from '@ember/object';
import Component from '@glimmer/component';

export default class InputComponent extends Component {
  @action
  async validateProperty(changeset, property) {
    if (this.args.onBlur) {
      this.args.onBlur(changeset);
    }
    return changeset?.validate(property);
  }

  @action
  handleInput(e) {
    if (!this.args.changeset) return;
    this.args.changeset.set(this.args.id, e.target.value);
  }
}
